const faqs = [
  {
    q: '亲亲漫画网真的完全免费吗？',
    a: '是的，亲亲漫画网所有漫画内容完全免费开放阅读，无需注册、无需付费、无需订阅。我们致力于为广大漫画爱好者提供零门槛的阅读体验，打开网站即可畅享海量韩漫、日漫、国漫作品。',
  },
  {
    q: '什么是下拉式阅读？如何操作？',
    a: '下拉式阅读是一种专为手机和网页优化的纵向滑动阅读方式。读者只需用手指或鼠标向下滑动屏幕，漫画内容便会自然滚动衔接，无需像传统翻页式阅读那样频繁点击。这种方式特别适合条漫和网络漫画的阅读习惯，体验流畅沉浸。',
  },
  {
    q: '亲亲漫画都有哪些类型的漫画？',
    a: '亲亲漫画涵盖韩漫、日漫、国漫三大品类，类型包括但不限于：浪漫恋爱、宫廷古装、热血冒险、玄幻修仙、悬疑推理、都市情感、搞笑日常、奇幻魔法等。无论你喜欢什么题材，都能在这里找到心仪的作品。平台收录超过十万部漫画，且每日持续更新。',
  },
  {
    q: '漫画更新频率是什么样的？',
    a: '热门连载漫画保持每日更新，每日新增超过200话内容。全本完结作品可直接一次性阅读至结局。我们与多家内容方保持合作，确保更新速度和内容质量，让你追更不等待、不错过任何精彩剧情。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
              <i className="ri-question-answer-line text-sm"></i>
              有问必答
            </div>
            <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 mb-3">
              常见问题
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              关于亲亲漫画的常见疑问，这里有你想知道的答案
            </p>
          </div>

          <div className="max-w-3xl mx-auto space-y-3 md:space-y-4">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
              >
                <div className="p-5 md:p-6">
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-3 flex items-start gap-3">
                    <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-xs font-bold mt-0.5">
                      Q
                    </span>
                    <span>{faq.q}</span>
                  </h3>
                  <div className="flex items-start gap-3">
                    <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 text-xs font-bold mt-0.5">
                      A
                    </span>
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}